import validate from '@/utils/validations/cns'

export default {
    validate,
    message: 'O CNS informado é inválido.',
}